import { render } from "./ScheduleTableRow.vue?vue&type=template&id=92ff1870"
import script from "./ScheduleTableRow.vue?vue&type=script&lang=ts"
export * from "./ScheduleTableRow.vue?vue&type=script&lang=ts"
script.render = render

export default script